// View
import ClaimInformationRequest from '@components/ClaimInformationRequest'

const config: Page.Config = {
  title: 'Submission Additional Details',
  dataset: ['submission'],
  view: ClaimInformationRequest,
  content: {},
}

export default config
